import React from 'react'
import { Inbox } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'

interface EmptyWorkspaceStateProps {
  reason: string
}

// Shared "no data synced yet" state for panels whose data source exists but isn't
// ready for this workspace (e.g. HubSpot not connected) — matches the hand-rolled
// empty-state visual pattern already used in KnowledgeBasePage.tsx (tinted icon
// circle + heading + subtext). Universal only for this story — the role-gated CTA
// button is deferred to ZAI-342.
const EmptyWorkspaceState: React.FC<EmptyWorkspaceStateProps> = ({ reason }) => {
  const { currentTheme: t } = useTheme()

  return (
    <div className="flex flex-col items-center justify-center py-8 gap-3 text-center">
      <div
        className="flex h-12 w-12 items-center justify-center rounded-xl shrink-0"
        style={{ backgroundColor: t.hoverBackground }}
      >
        <Inbox size={20} style={{ color: t.mutedText }} />
      </div>
      <div>
        <p className="text-sm font-semibold" style={{ color: t.text }}>No data synced yet</p>
        <p className="text-xs mt-1" style={{ color: t.mutedText }}>{reason}</p>
      </div>
    </div>
  )
}

export default React.memo(EmptyWorkspaceState)
